<template>
  <div id="app">
    <div v-if="this.$router.history.current.name !='login'" class="wrapper">
      <Sidebar />
      <div class="content">
        <Navbar />
        <DropdownQuickAction/>
        <div class="content-body p-4 scroll-bar">
          <router-view />
        </div>
      </div>
    </div>
     <div v-else>
          <router-view/>
     </div>


  </div>
</template>
<script>
import DropdownQuickAction from '@/components/dropdown-quick-actions';
import Navbar from "@/components/navbar";
import Sidebar from "@/components/sidebar";

// import { VueEvent } from '../../'

export default {
  name: "Home",

  data() {
    return {
      value: null,
     
    };
  },
  components: {
    Sidebar,
    Navbar,
    DropdownQuickAction
  },
};
</script>

